type Locales = {
  [key: string]: {
    [key: string]: {
      [key: string]: string;
    };
  };
};

export const getLocales = () => {
  const locales: Locales = {};
  const namespaces = ['header'];
  const langs = ['en', 'ru', 'es'];

  langs.forEach((lang) => {
    namespaces.forEach((ns) => {
      if (!locales[lang]) {
        locales[lang] = {
          [ns]: require(`../../locales/${lang}/${ns}.json`),
        };
      } else {
        locales[lang] = {
          ...locales[lang],
          [ns]: require(`../../locales/${lang}/${ns}.json`),
        };
      }
    });
  });

  return locales;
};
